import React from 'react';
import { connect } from 'react-redux'
import {
  show_archive_sidebar_feed_actions,
  hide_archive_sidebar_feed_actions,
  get_project,
  destroy_feed,
  // feeds_archive,
  project_archive,
  restore_feed
} from '../actions'
import { Link, Redirect } from 'react-router-dom'
import Pagination from './Pagination'
import Loading from './Loading';
import {
  is_logged_on,
  is_validating
 } from "../helpers"

const mapStateToProps = state => {
  return {
    feed: state.feed
  };
};

const mapDispatchToProps = dispatch => {
    return {
      // getFeeds: (page) => dispatch ( feeds_archive(page) ),
      destroyFeed: (id, page) => dispatch ( destroy_feed(id, page) ),
      getProject: (id) => dispatch ( get_project(id) ),
      restoreFeed: (feed_id, page) => dispatch ( restore_feed(feed_id, page) ),
      projectArchive: (feed_id, page) => dispatch( project_archive(feed_id, page) ),
      showActions: () => dispatch ( show_archive_sidebar_feed_actions() ),
      hideActions: () => dispatch ( hide_archive_sidebar_feed_actions() )
    }
}

class ConnectedArchives extends React.Component {
  constructor () {
    super()
    this.state = {
      clickedId: ''
    }
  }

  setCurrent(id) {
    this.setState({clickedId: id})
  }

  resetCurrent() {
    this.setState({clickedId: ''})
  }

  destroyFeed(feed_id) {
    this.setState({clickedId: ''})
    const {page} = this.props.feed.feed.pagination
    this.props.destroyFeed(feed_id, page)
  }

  restoreFeed(feed_id) {
    this.setState({clickedId: ''})
    const {page} = this.props.feed.feed.pagination
    this.props.restoreFeed(feed_id, page)
  }

  componentDidMount() {
    const {id} = this.props.match.params
    console.log(id)
    this.props.showActions()
    this.props.projectArchive(id, 1)
  }

  componentWillUnmount() {
    this.props.hideActions()
  }

  render() {
    if ( !is_validating() && !is_logged_on() ) {
      return <Redirect to="/login" />
    }

    const { fetching, fetched } = this.props.feed;

    if ( fetching || ! fetched ) {
      return (
       <Loading />
      )
    }

    const feeds = (typeof( this.props.feed.feed.archives ) === "undefined") ? [] : this.props.feed.feed.archives


    const { pagination } = this.props.feed.feed;

    return (
      <div className="collection with-header">
				<div className="collection-header red darken-1 white-text">
					<span className="flow-text">Project: {this.props.feed.feed.name} | Archived Instances</span>
					<i className="material-icons right">delete</i>
				</div>
				<table className="bordered striped highlight responsive-table">
					<thead>
						<tr>
							<th>Project Name</th>
							<th>Date Archived</th>
              {
                // <th>User</th>
              }
							<th>Details</th>
							<th>Status</th>
							<th>Actions</th>
						</tr>
					</thead>
				 	<tbody>
						{feeds.map(function(feed){
							const {id, name, deleted_at, entries, new_entries, removed} = feed;
              const current = this.state.clickedId

              let links
              if (feed.id !== current) {
                links = (
                  <div className="meta" onMouseLeave={(e) => {
                    this.resetCurrent()
                  }}>
                    <Link className="c-darkgrey" to={`/feeds/${feed.id}/entries`}>View</Link> |
                    <Link
                      className="red-text"
                      to="#"
                      onClick={(e)=>{
                        e.preventDefault()
                        this.setCurrent(feed.id)
                      }}
                      >Permanently Delete</Link>
                  </div>
                )
              } else {
                links = (
                  <div className="meta">
                    <Link className="c-darkgrey" to="#" onClick={(e)=>{
                      e.preventDefault()
                      this.resetCurrent()
                    }}>Cancel</Link> |
                    <Link
                      className="red-text"
                      to="#"
                      onClick={(e)=>{
                        e.preventDefault()
                        this.destroyFeed(feed.id)
                      }}
                      >Are you sure?</Link>
                  </div>
                )
              }

							return (
								<tr key={id}>
									<td>
										<Link className="view" to={`/feeds/${feed.id}/entries`}>{name}</Link>
                    { links }
									</td>
									<td>{new Date(deleted_at).toLocaleDateString()}, {new Date(deleted_at).toLocaleTimeString()}</td>
                  {
                    // <td>user here</td>
                  }
									<td>
                    <small><p>{entries} Rows Total</p></small>
                    <small><p>{new_entries} Unreviewed Rows</p></small>
                    <small><p>{removed} Deleted Rows</p></small>
									</td>
									<td>
										<i className="material-icons c-grey">restore</i>
									</td>
									<td>
										<button className="btn red darken-1 waves-effect waves-light" onClick={(e)=>{
                      e.preventDefault()
                      this.restoreFeed(feed.id)
                    }}>RESTORE</button>
									</td>
								</tr>
							)
						}, this)}
			 		</tbody>
				</table>
        <Pagination pagination={pagination} fetchPage={this.props.projectArchive}/>
      </div>
    )
  }

}

const Archives = connect(mapStateToProps, mapDispatchToProps)(ConnectedArchives);

export default Archives;



// WEBPACK FOOTER //
// ./src/js/components/ProjectArchives.js